import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { closeModal } from '../actions/modalActions'
import { createAlert } from '../actions/alertActions'
import { connect } from 'react-redux'
import JoinLiveModal from '../components/JoinLiveModal'
import { getLiveCookies } from '../utils/api'

export const JOIN_LIVE_MODAL_ID = 'JOIN_LIVE_MODAL'

const mapStateToProps = state => ({
  open: state.modals[JOIN_LIVE_MODAL_ID],
  features: state.features
})

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeModal(JOIN_LIVE_MODAL_ID)),
  createAlert: alert => dispatch(createAlert(alert))
})

const secureLoginRedirectUrl = (jwt, backroom = false) => {
  const baseUrl = `${process.env.FVSS_SECURE_LOGIN_REDIRECT_URL}?token=${jwt}`
  return backroom ? `${baseUrl}&viewerLocation=2` : baseUrl
}

@connect(mapStateToProps, mapDispatchToProps)
export default class JoinLiveModalContainer extends Component {
  static propTypes = {
    createAlert: PropTypes.func,
    jwt: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool,
    playerUrl: PropTypes.string,
    sourceType: PropTypes.string.isRequired,
    features: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)
    const { playerUrl, features, jwt } = this.props

    if (!this.isIntervu()) {
      return
    }

    if (features.includes('20200317_secure_login_redirect')) {
      return (window.location.href = secureLoginRedirectUrl(jwt))
    }

    this.getCookies().then(() => {
      window.location.href = playerUrl
    })
  }

  state = {
    location: null
  }

  handleClose = () => {
    this.setState({ location: null })
    this.props.onClose()
  }

  getCookies = () => {
    const { jwt } = this.props

    return getLiveCookies({ jwt })
  }

  handleJoin = () => {
    const { playerUrl, createAlert, features, jwt } = this.props
    const { location } = this.state

    if (features.includes('20200317_secure_login_redirect')) {
      return (window.location.href = secureLoginRedirectUrl(
        jwt,
        location === 'backroom'
      ))
    }

    this.getCookies()
      .then(() => {
        if (location === 'backroom') {
          return (window.location.href = `${playerUrl}&ViewerLocation=2`)
        }

        window.location.href = playerUrl
      })
      .catch(() => {
        createAlert({
          type: 'ERROR',
          message: 'Something went wrong, please contact support.',
          scope: 'joinModal'
        })
      })
  }

  isIntervu() {
    const { sourceType } = this.props
    return sourceType === 'InterVu'
  }

  render() {
    const { location } = this.state
    const { open } = this.props

    return (
      <JoinLiveModal
        location={location}
        open={open && !this.isIntervu()}
        onClose={this.handleClose}
        onJoin={this.handleJoin}
        onSelectLocation={location => this.setState({ location })}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/containers/JoinLiveModalContainer.js